import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslation } from "../../contexts/translation-context.js";
import { SupportedDateParts } from "../../utils/date-format-parts.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import styles from "./date-components.module.scss";
import { DayFieldWUT } from "./day-field/day-field-wut.js";
import { serializeDate } from "./helpers.js";
import { MonthSelectWUT } from "./month-select/month-select-wut.js";
import { YearFieldWUT } from "./year-field/year-field-wut.js";
const dateComponentsWUT = {
  [SupportedDateParts.DAY]: DayFieldWUT,
  [SupportedDateParts.MONTH]: MonthSelectWUT,
  [SupportedDateParts.YEAR]: YearFieldWUT
};
const getDateComponentWUT = (datePart) => {
  const Field = dateComponentsWUT[datePart];
  if (!Field) {
    return () => null;
  }
  return function DateComponent({
    id,
    inputId,
    hidePlaceholder,
    showDateLabels,
    onChange,
    values,
    errors,
    ...rest
  }) {
    const { t } = useTranslation();
    const placeholderText = hidePlaceholder ? void 0 : t(`field.date.placeholder.${datePart.toLowerCase()}`);
    const value = values[datePart];
    const hasError = errors[datePart];
    const label = t(`field.date.label.${datePart.toLowerCase()}`);
    return /* @__PURE__ */ jsxs("div", { className: styles[datePart], children: [
      /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId: `form-field-sub-label-${datePart}-${inputId}`,
          label,
          hideLabel: !showDateLabels,
          required: false
        }
      ),
      /* @__PURE__ */ jsx(
        Field,
        {
          ...rest,
          id,
          error: hasError,
          value,
          "data-date-field": true,
          "data-hook": datePart,
          placeholder: placeholderText,
          onChange: (newValue) => onChange(serializeDate(newValue, datePart, values))
        }
      )
    ] });
  };
};
export {
  getDateComponentWUT
};
//# sourceMappingURL=date-components-wut.js.map
